// // import React, { useState } from "react";
// // import {
// //     FaBell,
// //     FaHistory,
// //     FaCalendarAlt,
// //     FaFilter,
// //     FaTrash,
// //     FaSearch,
// //     FaEye,
// //     FaBox,
// //     FaShoppingCart,
// //     FaStar,
// //     FaRupeeSign,
// //     FaCog,
// //     FaSms,
// //     FaMobileAlt,
// //     FaEnvelope,
// //     FaSortAmountDown,
// //     FaSortAmountUp,
// //     FaCheckCircle
// // } from "react-icons/fa";

// // const NotificationHistory = () => {
// //     const isMobile = window.innerWidth <= 768;
    
// //     const [notifications, setNotifications] = useState([
// //         {
// //             id: 1,
// //             type: 'stock',
// //             title: 'Low Stock Alert',
// //             message: 'Paneer Tikka is running low (5 items left)',
// //             timestamp: '2024-03-20 14:30:00',
// //             read: true,
// //             channel: 'sms',
// //             priority: 'high'
// //         },
// //         {
// //             id: 2,
// //             type: 'order',
// //             title: 'High-Value Order',
// //             message: 'Order #ORD-78945 worth ₹12,500 received',
// //             timestamp: '2024-03-20 12:15:00',
// //             read: true,
// //             channel: 'sms',
// //             priority: 'high'
// //         },
// //         {
// //             id: 3,
// //             type: 'payment',
// //             title: 'Payment Received',
// //             message: '₹8,750 payment processed for Order #ORD-78945',
// //             timestamp: '2024-03-20 09:20:00',
// //             read: false,
// //             channel: 'sms',
// //             priority: 'medium'
// //         },
// //         {
// //             id: 4,
// //             type: 'stock',
// //             title: 'Critical Stock Level',
// //             message: 'Basmati Rice needs restocking (2 items left)',
// //             timestamp: '2024-03-19 11:30:00',
// //             read: true,
// //             channel: 'sms',
// //             priority: 'critical'
// //         },
// //         {
// //             id: 5,
// //             type: 'system',
// //             title: 'System Maintenance',
// //             message: 'Scheduled maintenance on March 22, 2:00 AM - 4:00 AM',
// //             timestamp: '2024-03-19 16:10:00',
// //             read: false,
// //             channel: 'push',
// //             priority: 'low'
// //         },
// //         {
// //             id: 6,
// //             type: 'order',
// //             title: 'Order Confirmation',
// //             message: 'Order #ORD-78946 confirmed for ₹2,450',
// //             timestamp: '2024-03-19 14:45:00',
// //             read: true,
// //             channel: 'sms',
// //             priority: 'medium'
// //         },
// //         {
// //             id: 7,
// //             type: 'stock',
// //             title: 'Restock Reminder',
// //             message: 'Butter Chicken Masala running low (8 items left)',
// //             timestamp: '2024-03-19 10:15:00',
// //             read: true,
// //             channel: 'sms',
// //             priority: 'medium'
// //         },
// //         {
// //             id: 8,
// //             type: 'payment',
// //             title: 'Payment Failed',
// //             message: 'Payment failed for Order #ORD-78947. Please check.',
// //             timestamp: '2024-03-18 18:30:00',
// //             read: true,
// //             channel: 'sms',
// //             priority: 'high'
// //         }
// //     ]);

// //     const [filterType, setFilterType] = useState('all');
// //     const [searchQuery, setSearchQuery] = useState('');
// //     const [sortOrder, setSortOrder] = useState('newest');

// //     const getPriorityColor = (priority) => {
// //         switch (priority) {
// //             case 'critical': return '#f44336';
// //             case 'high': return '#ff9800';
// //             case 'medium': return '#2196f3';
// //             case 'low': return '#4caf50';
// //             default: return '#757575';
// //         }
// //     };

// //     const getTypeIcon = (type) => {
// //         switch (type) {
// //             case 'stock': return <FaBox />;
// //             case 'order': return <FaShoppingCart />;
// //             case 'review': return <FaStar />;
// //             case 'payment': return <FaRupeeSign />;
// //             case 'system': return <FaCog />;
// //             default: return <FaBell />;
// //         }
// //     };

// //     const getChannelIcon = (channel) => {
// //         switch (channel) {
// //             case 'sms': return <FaSms />;
// //             case 'push': return <FaMobileAlt />;
// //             case 'email': return <FaEnvelope />;
// //             default: return <FaBell />;
// //         }
// //     };

// //     const markAsRead = (id) => {
// //         setNotifications(prev =>
// //             prev.map(notification =>
// //                 notification.id === id ? { ...notification, read: true } : notification
// //             )
// //         );
// //     };

// //     const markAllAsRead = () => {
// //         setNotifications(prev =>
// //             prev.map(notification => ({ ...notification, read: true }))
// //         );
// //     };

// //     const deleteNotification = (id) => {
// //         setNotifications(prev =>
// //             prev.filter(notification => notification.id !== id)
// //         );
// //     };

// //     const clearAllNotifications = () => {
// //         setNotifications([]);
// //     };

// //     const filteredNotifications = notifications
// //         .filter(notification => {
// //             const matchesType = filterType === 'all' || notification.type === filterType;
// //             const matchesSearch =
// //                 notification.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
// //                 notification.message.toLowerCase().includes(searchQuery.toLowerCase());

// //             return matchesType && matchesSearch;
// //         })
// //         .sort((a, b) => {
// //             const dateA = new Date(a.timestamp);
// //             const dateB = new Date(b.timestamp);
// //             return sortOrder === 'newest' ? dateB - dateA : dateA - dateB;
// //         });

// //     const unreadCount = notifications.filter(n => !n.read).length;

// //     const notificationTypes = [
// //         { id: 'all', label: 'All' },
// //         { id: 'stock', label: 'Stock' },
// //         { id: 'order', label: 'Orders' },
// //         { id: 'payment', label: 'Payments' },
// //         { id: 'system', label: 'System' }
// //     ];

// //     return (
// //         <div style={{
// //             backgroundColor: 'white',
// //             borderRadius: '10px',
// //             padding: isMobile ? '15px' : '30px',
// //             boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
// //         }}>
// //             <div style={{
// //                 display: 'flex',
// //                 justifyContent: 'space-between',
// //                 alignItems: 'center',
// //                 marginBottom: '20px',
// //                 flexWrap: 'wrap',
// //                 gap: '15px',
// //                 flexDirection: isMobile ? 'column' : 'row'
// //             }}>
// //                 <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
// //                     <h3 style={{
// //                         margin: 0,
// //                         color: '#333',
// //                         fontSize: isMobile ? '18px' : '24px'
// //                     }}>
// //                         Notification History
// //                     </h3>
// //                     <p style={{
// //                         margin: '5px 0 0 0',
// //                         color: '#666',
// //                         fontSize: isMobile ? '13px' : '14px'
// //                     }}>
// //                         View all your past notifications
// //                     </p>
// //                 </div>

// //                 <div style={{
// //                     display: 'flex',
// //                     gap: '10px',
// //                     flexWrap: 'wrap',
// //                     justifyContent: isMobile ? 'center' : 'flex-end'
// //                 }}>
// //                     <button
// //                         onClick={markAllAsRead}
// //                         style={{
// //                             backgroundColor: '#4CAF50',
// //                             color: 'white',
// //                             border: 'none',
// //                             padding: isMobile ? '8px 16px' : '10px 20px',
// //                             borderRadius: '6px',
// //                             cursor: 'pointer',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: isMobile ? '5px' : '8px',
// //                             fontSize: isMobile ? '13px' : '14px',
// //                             fontWeight: '600'
// //                         }}
// //                     >
// //                         <FaCheckCircle /> Mark All as Read
// //                     </button>

// //                     <button
// //                         onClick={clearAllNotifications}
// //                         style={{
// //                             backgroundColor: '#f44336',
// //                             color: 'white',
// //                             border: 'none',
// //                             padding: isMobile ? '8px 16px' : '10px 20px',
// //                             borderRadius: '6px',
// //                             cursor: 'pointer',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: isMobile ? '5px' : '8px',
// //                             fontSize: isMobile ? '13px' : '14px',
// //                             fontWeight: '600'
// //                         }}
// //                     >
// //                         <FaTrash /> Clear All
// //                     </button>
// //                 </div>
// //             </div>

// //             {/* Filters and Search */}
// //             <div style={{
// //                 backgroundColor: '#f8f9fa',
// //                 padding: isMobile ? '15px' : '20px',
// //                 borderRadius: '10px',
// //                 marginBottom: '20px'
// //             }}>
// //                 <div style={{
// //                     display: 'flex',
// //                     flexDirection: isMobile ? 'column' : 'row',
// //                     gap: '15px',
// //                     alignItems: isMobile ? 'stretch' : 'center'
// //                 }}>
// //                     <div style={{
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         gap: '10px',
// //                         flexWrap: 'wrap',
// //                         justifyContent: isMobile ? 'center' : 'flex-start'
// //                     }}>
// //                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
// //                             <FaFilter style={{ color: '#666' }} />
// //                             <span style={{
// //                                 fontSize: isMobile ? '13px' : '14px',
// //                                 fontWeight: '600',
// //                                 color: '#333'
// //                             }}>
// //                                 Filter:
// //                             </span>
// //                         </div>
// //                         <div style={{
// //                             display: 'flex',
// //                             gap: '8px',
// //                             flexWrap: 'wrap',
// //                             justifyContent: isMobile ? 'center' : 'flex-start'
// //                         }}>
// //                             {notificationTypes.map(type => (
// //                                 <button
// //                                     key={type.id}
// //                                     onClick={() => setFilterType(type.id)}
// //                                     style={{
// //                                         padding: isMobile ? '6px 12px' : '8px 16px',
// //                                         border: 'none',
// //                                         backgroundColor: filterType === type.id ? '#A055B0' : '#e0e0e0',
// //                                         color: filterType === type.id ? 'white' : '#333',
// //                                         borderRadius: '20px',
// //                                         cursor: 'pointer',
// //                                         fontSize: isMobile ? '12px' : '13px',
// //                                         fontWeight: '600',
// //                                         flexShrink: 0
// //                                     }}
// //                                 >
// //                                     {type.label}
// //                                 </button>
// //                             ))}
// //                         </div>
// //                     </div>

// //                     <div style={{
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         gap: '10px',
// //                         marginLeft: isMobile ? '0' : 'auto'
// //                     }}>
// //                         <button
// //                             onClick={() => setSortOrder(sortOrder === 'newest' ? 'oldest' : 'newest')}
// //                             style={{
// //                                 padding: isMobile ? '6px 12px' : '8px 16px',
// //                                 border: '1px solid #ddd',
// //                                 backgroundColor: 'white',
// //                                 color: '#333',
// //                                 borderRadius: '6px',
// //                                 cursor: 'pointer',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 gap: '6px',
// //                                 fontSize: isMobile ? '12px' : '13px',
// //                                 fontWeight: '600',
// //                                 flexShrink: 0
// //                             }}
// //                         >
// //                             {sortOrder === 'newest' ? <FaSortAmountDown /> : <FaSortAmountUp />}
// //                             {sortOrder === 'newest' ? 'Newest' : 'Oldest'}
// //                         </button>

// //                         <div style={{
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: '8px',
// //                             flex: isMobile ? 1 : 'none'
// //                         }}>
// //                             <FaSearch style={{ color: '#666' }} />
// //                             <input
// //                                 type="text"
// //                                 placeholder="Search notifications..."
// //                                 value={searchQuery}
// //                                 onChange={(e) => setSearchQuery(e.target.value)}
// //                                 style={{
// //                                     padding: isMobile ? '8px 12px' : '10px 15px',
// //                                     border: '1px solid #ddd',
// //                                     borderRadius: '6px',
// //                                     fontSize: isMobile ? '13px' : '14px',
// //                                     width: '100%',
// //                                     minWidth: isMobile ? 'auto' : '200px',
// //                                     boxSizing: 'border-box'
// //                                 }}
// //                             />
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>

// //             {/* Notifications List */}
// //             <div style={{
// //                 backgroundColor: '#fff',
// //                 borderRadius: '10px',
// //                 border: '1px solid #e0e0e0',
// //                 overflow: 'hidden',
// //                 minHeight: '300px',
// //                 marginBottom: '20px',
// //                 maxHeight: '500px',
// //                 overflowY: 'auto',
// //                 scrollBehavior: 'smooth'
// //             }}>
// //                 {filteredNotifications.length === 0 ? (
// //                     <div style={{
// //                         padding: isMobile ? '40px 20px' : '60px 20px',
// //                         textAlign: 'center',
// //                         color: '#666'
// //                     }}>
// //                         <FaBell style={{
// //                             fontSize: isMobile ? '48px' : '64px',
// //                             marginBottom: '15px',
// //                             opacity: 0.3
// //                         }} />
// //                         <h4 style={{
// //                             margin: '0 0 10px 0',
// //                             color: '#333',
// //                             fontSize: isMobile ? '16px' : '18px'
// //                         }}>
// //                             No notifications found
// //                         </h4>
// //                         <p style={{
// //                             fontSize: isMobile ? '13px' : '14px',
// //                             margin: 0
// //                         }}>
// //                             Try adjusting your filters or search terms
// //                         </p>
// //                     </div>
// //                 ) : (
// //                     filteredNotifications.map(notification => (
// //                         <div
// //                             key={notification.id}
// //                             style={{
// //                                 padding: isMobile ? '12px 15px' : '15px 20px',
// //                                 borderBottom: '1px solid #e0e0e0',
// //                                 backgroundColor: notification.read ? '#fff' : '#f8f9fa',
// //                                 display: 'flex',
// //                                 alignItems: 'flex-start',
// //                                 gap: isMobile ? '10px' : '15px',
// //                                 position: 'relative'
// //                             }}
// //                         >
// //                             {/* Unread Indicator */}
// //                             {!notification.read && (
// //                                 <div style={{
// //                                     position: 'absolute',
// //                                     left: '0',
// //                                     top: '0',
// //                                     bottom: '0',
// //                                     width: '4px',
// //                                     backgroundColor: getPriorityColor(notification.priority)
// //                                 }}></div>
// //                             )}

// //                             {/* Notification Icon */}
// //                             <div style={{
// //                                 width: isMobile ? '40px' : '50px',
// //                                 height: isMobile ? '40px' : '50px',
// //                                 borderRadius: '8px',
// //                                 backgroundColor: getPriorityColor(notification.priority) + '20',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 color: getPriorityColor(notification.priority),
// //                                 fontSize: isMobile ? '18px' : '22px',
// //                                 flexShrink: 0
// //                             }}>
// //                                 {getTypeIcon(notification.type)}
// //                             </div>

// //                             {/* Notification Content */}
// //                             <div style={{ flex: 1, minWidth: 0 }}>
// //                                 <div style={{
// //                                     display: 'flex',
// //                                     flexDirection: isMobile ? 'column' : 'row',
// //                                     justifyContent: 'space-between',
// //                                     alignItems: isMobile ? 'flex-start' : 'flex-start',
// //                                     marginBottom: '8px',
// //                                     gap: isMobile ? '8px' : '0'
// //                                 }}>
// //                                     <div style={{ flex: 1, minWidth: 0 }}>
// //                                         <div style={{
// //                                             display: 'flex',
// //                                             alignItems: 'center',
// //                                             gap: '8px',
// //                                             marginBottom: '5px',
// //                                             flexWrap: 'wrap'
// //                                         }}>
// //                                             <h4 style={{
// //                                                 margin: 0,
// //                                                 fontSize: isMobile ? '14px' : '16px',
// //                                                 color: '#333',
// //                                                 fontWeight: notification.read ? '600' : '700',
// //                                                 wordBreak: 'break-word'
// //                                             }}>
// //                                                 {notification.title}
// //                                             </h4>
// //                                             <span style={{
// //                                                 fontSize: isMobile ? '10px' : '11px',
// //                                                 color: 'white',
// //                                                 backgroundColor: getPriorityColor(notification.priority),
// //                                                 padding: '2px 8px',
// //                                                 borderRadius: '10px',
// //                                                 textTransform: 'uppercase',
// //                                                 fontWeight: 'bold',
// //                                                 flexShrink: 0
// //                                             }}>
// //                                                 {notification.priority}
// //                                             </span>
// //                                         </div>
// //                                         <p style={{
// //                                             margin: '0 0 8px 0',
// //                                             fontSize: isMobile ? '13px' : '14px',
// //                                             color: '#666',
// //                                             lineHeight: '1.5',
// //                                             wordBreak: 'break-word'
// //                                         }}>
// //                                             {notification.message}
// //                                         </p>
// //                                     </div>

// //                                     <div style={{
// //                                         display: 'flex',
// //                                         flexDirection: 'column',
// //                                         gap: '6px',
// //                                         alignItems: isMobile ? 'flex-start' : 'flex-end',
// //                                         width: isMobile ? '100%' : 'auto'
// //                                     }}>
// //                                         <div style={{
// //                                             display: 'flex',
// //                                             alignItems: 'center',
// //                                             gap: '10px',
// //                                             flexWrap: 'wrap'
// //                                         }}>
// //                                             <span style={{
// //                                                 fontSize: isMobile ? '11px' : '12px',
// //                                                 color: '#999',
// //                                                 display: 'flex',
// //                                                 alignItems: 'center',
// //                                                 gap: '5px',
// //                                                 flexShrink: 0
// //                                             }}>
// //                                                 <FaCalendarAlt /> {notification.timestamp}
// //                                             </span>

// //                                             <span style={{
// //                                                 fontSize: isMobile ? '11px' : '12px',
// //                                                 color: '#666',
// //                                                 display: 'flex',
// //                                                 alignItems: 'center',
// //                                                 gap: '5px',
// //                                                 flexShrink: 0
// //                                             }}>
// //                                                 {getChannelIcon(notification.channel)}
// //                                                 <span style={{ textTransform: 'capitalize' }}>
// //                                                     {notification.channel}
// //                                                 </span>
// //                                             </span>
// //                                         </div>

// //                                         {/* Action Buttons */}
// //                                         <div style={{
// //                                             display: 'flex',
// //                                             gap: '8px',
// //                                             flexWrap: 'wrap'
// //                                         }}>
// //                                             {!notification.read && (
// //                                                 <button
// //                                                     onClick={() => markAsRead(notification.id)}
// //                                                     style={{
// //                                                         backgroundColor: 'transparent',
// //                                                         color: '#2196F3',
// //                                                         border: '1px solid #2196F3',
// //                                                         padding: '4px 10px',
// //                                                         borderRadius: '4px',
// //                                                         cursor: 'pointer',
// //                                                         fontSize: isMobile ? '12px' : '13px',
// //                                                         display: 'flex',
// //                                                         alignItems: 'center',
// //                                                         gap: '5px',
// //                                                         flexShrink: 0
// //                                                     }}
// //                                                 >
// //                                                     <FaCheckCircle /> Read
// //                                                 </button>
// //                                             )}

// //                                             <button
// //                                                 onClick={() => deleteNotification(notification.id)}
// //                                                 style={{
// //                                                     backgroundColor: 'transparent',
// //                                                     color: '#f44336',
// //                                                     border: '1px solid #f44336',
// //                                                     padding: '4px 10px',
// //                                                     borderRadius: '4px',
// //                                                     cursor: 'pointer',
// //                                                     fontSize: isMobile ? '12px' : '13px',
// //                                                     display: 'flex',
// //                                                     alignItems: 'center',
// //                                                     gap: '5px',
// //                                                     flexShrink: 0
// //                                                 }}
// //                                             >
// //                                                 <FaTrash /> Delete
// //                                             </button>

// //                                             <button
// //                                                 onClick={() => alert(`Viewing details for: ${notification.title}`)}
// //                                                 style={{
// //                                                     backgroundColor: 'transparent',
// //                                                     color: '#4CAF50',
// //                                                     border: '1px solid #4CAF50',
// //                                                     padding: '4px 10px',
// //                                                     borderRadius: '4px',
// //                                                     cursor: 'pointer',
// //                                                     fontSize: isMobile ? '12px' : '13px',
// //                                                     display: 'flex',
// //                                                     alignItems: 'center',
// //                                                     gap: '5px',
// //                                                     flexShrink: 0
// //                                                 }}
// //                                             >
// //                                                 <FaEye /> Details
// //                                             </button>
// //                                         </div>
// //                                     </div>
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     ))
// //                 )}
// //             </div>

// //             {/* Stats Summary */}
// //             <div style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
// //                 gap: '15px'
// //             }}>
// //                 <div style={{
// //                     backgroundColor: '#e8f5e9',
// //                     padding: isMobile ? '15px' : '20px',
// //                     borderRadius: '10px',
// //                     textAlign: 'center'
// //                 }}>
// //                     <div style={{
// //                         fontSize: isMobile ? '20px' : '28px',
// //                         fontWeight: 'bold',
// //                         color: '#2e7d32'
// //                     }}>
// //                         {notifications.length}
// //                     </div>
// //                     <div style={{
// //                         fontSize: isMobile ? '12px' : '14px',
// //                         color: '#388e3c',
// //                         fontWeight: '600'
// //                     }}>
// //                         Total Notifications
// //                     </div>
// //                 </div>

// //                 <div style={{
// //                     backgroundColor: '#fff3e0',
// //                     padding: isMobile ? '15px' : '20px',
// //                     borderRadius: '10px',
// //                     textAlign: 'center'
// //                 }}>
// //                     <div style={{
// //                         fontSize: isMobile ? '20px' : '28px',
// //                         fontWeight: 'bold',
// //                         color: '#e65100'
// //                     }}>
// //                         {unreadCount}
// //                     </div>
// //                     <div style={{
// //                         fontSize: isMobile ? '12px' : '14px',
// //                         color: '#ef6c00',
// //                         fontWeight: '600'
// //                     }}>
// //                         Unread
// //                     </div>
// //                 </div>

// //                 <div style={{
// //                     backgroundColor: '#e3f2fd',
// //                     padding: isMobile ? '15px' : '20px',
// //                     borderRadius: '10px',
// //                     textAlign: 'center'
// //                 }}>
// //                     <div style={{
// //                         fontSize: isMobile ? '20px' : '28px',
// //                         fontWeight: 'bold',
// //                         color: '#1565c0'
// //                     }}>
// //                         {notifications.filter(n => n.channel === 'sms').length}
// //                     </div>
// //                     <div style={{
// //                         fontSize: isMobile ? '12px' : '14px',
// //                         color: '#1976d2',
// //                         fontWeight: '600'
// //                     }}>
// //                         SMS Notifications
// //                     </div>
// //                 </div>

// //                 <div style={{
// //                     backgroundColor: '#f3e5f5',
// //                     padding: isMobile ? '15px' : '20px',
// //                     borderRadius: '10px',
// //                     textAlign: 'center'
// //                 }}>
// //                     <div style={{
// //                         fontSize: isMobile ? '20px' : '28px',
// //                         fontWeight: 'bold',
// //                         color: '#7b1fa2'
// //                     }}>
// //                         {notifications.filter(n => n.type === 'stock').length}
// //                     </div>
// //                     <div style={{
// //                         fontSize: isMobile ? '12px' : '14px',
// //                         color: '#8e24aa',
// //                         fontWeight: '600'
// //                     }}>
// //                         Stock Alerts
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // export default NotificationHistory;




// import React, { useState } from "react";
// import {
//     FaBell,
//     FaHistory,
//     FaCheckCircle,
//     FaTrash,
//     FaFilter,
//     FaSearch,
//     FaEye,
//     FaCalendarAlt,
//     FaSortAmountDown,
//     FaSortAmountUp,
//     FaBox,
//     FaShoppingCart,
//     FaStar,
//     FaRupeeSign,
//     FaCog,
//     FaSms,
//     FaMobileAlt,
//     FaEnvelope
// } from "react-icons/fa";

// function NotificationHistory({ isMobile }) {
//     // State for notification history
//     const [notifications, setNotifications] = useState([
//         {
//             id: 1,
//             type: 'stock',
//             title: 'Low Stock Alert',
//             message: 'Paneer Tikka is running low (5 items left)',
//             timestamp: '2024-03-20 14:30:00',
//             read: true,
//             channel: 'sms',
//             priority: 'high'
//         },
//         {
//             id: 2,
//             type: 'order',
//             title: 'High-Value Order',
//             message: 'Order #ORD-78945 worth ₹12,500 received',
//             timestamp: '2024-03-20 12:15:00',
//             read: true,
//             channel: 'sms',
//             priority: 'high'
//         },
//         {
//             id: 3,
//             type: 'payment',
//             title: 'Payment Received',
//             message: '₹8,750 payment processed for Order #ORD-78945',
//             timestamp: '2024-03-20 09:20:00',
//             read: false,
//             channel: 'sms',
//             priority: 'medium'
//         },
//         {
//             id: 4,
//             type: 'stock',
//             title: 'Critical Stock Level',
//             message: 'Basmati Rice needs restocking (2 items left)',
//             timestamp: '2024-03-19 11:30:00',
//             read: true,
//             channel: 'sms',
//             priority: 'critical'
//         },
//         {
//             id: 5,
//             type: 'system',
//             title: 'System Maintenance',
//             message: 'Scheduled maintenance on March 22, 2:00 AM - 4:00 AM',
//             timestamp: '2024-03-19 16:10:00',
//             read: false,
//             channel: 'push',
//             priority: 'low'
//         },
//         {
//             id: 6,
//             type: 'order',
//             title: 'Order Confirmation',
//             message: 'Order #ORD-78946 confirmed for ₹2,450',
//             timestamp: '2024-03-19 14:45:00',
//             read: true,
//             channel: 'sms',
//             priority: 'medium'
//         },
//         {
//             id: 7,
//             type: 'stock',
//             title: 'Restock Reminder',
//             message: 'Butter Chicken Masala running low (8 items left)',
//             timestamp: '2024-03-19 10:15:00',
//             read: true,
//             channel: 'sms',
//             priority: 'medium'
//         },
//         {
//             id: 8,
//             type: 'payment',
//             title: 'Payment Failed',
//             message: 'Payment failed for Order #ORD-78947. Please check.',
//             timestamp: '2024-03-18 18:30:00',
//             read: true,
//             channel: 'sms',
//             priority: 'high'
//         }
//     ]);

//     // State for UI
//     const [filterType, setFilterType] = useState('all');
//     const [searchQuery, setSearchQuery] = useState('');
//     const [sortOrder, setSortOrder] = useState('newest');

//     // Mark notification as read
//     const markAsRead = (id) => {
//         setNotifications(prev =>
//             prev.map(notification =>
//                 notification.id === id ? { ...notification, read: true } : notification
//             )
//         );
//     };

//     // Mark all as read
//     const markAllAsRead = () => {
//         setNotifications(prev =>
//             prev.map(notification => ({ ...notification, read: true }))
//         );
//     };

//     // Delete notification
//     const deleteNotification = (id) => {
//         setNotifications(prev =>
//             prev.filter(notification => notification.id !== id)
//         );
//     };

//     // Clear all notifications
//     const clearAllNotifications = () => {
//         setNotifications([]);
//     };

//     // Filter and sort notifications
//     const filteredNotifications = notifications
//         .filter(notification => {
//             const matchesType = filterType === 'all' || notification.type === filterType;
//             const matchesSearch =
//                 notification.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                 notification.message.toLowerCase().includes(searchQuery.toLowerCase());

//             return matchesType && matchesSearch;
//         })
//         .sort((a, b) => {
//             const dateA = new Date(a.timestamp);
//             const dateB = new Date(b.timestamp);
//             return sortOrder === 'newest' ? dateB - dateA : dateA - dateB;
//         });

//     // Get unread count
//     const unreadCount = notifications.filter(n => !n.read).length;

//     // Get priority color
//     const getPriorityColor = (priority) => {
//         switch (priority) {
//             case 'critical': return '#f44336';
//             case 'high': return '#ff9800';
//             case 'medium': return '#2196f3';
//             case 'low': return '#4caf50';
//             default: return '#757575';
//         }
//     };

//     // Get type icon
//     const getTypeIcon = (type) => {
//         switch (type) {
//             case 'stock': return <FaBox />;
//             case 'order': return <FaShoppingCart />;
//             case 'review': return <FaStar />;
//             case 'payment': return <FaRupeeSign />;
//             case 'system': return <FaCog />;
//             default: return <FaBell />;
//         }
//     };

//     // Get channel icon
//     const getChannelIcon = (channel) => {
//         switch (channel) {
//             case 'sms': return <FaSms />;
//             case 'push': return <FaMobileAlt />;
//             case 'email': return <FaEnvelope />;
//             default: return <FaBell />;
//         }
//     };

//     // Notification types for filtering
//     const notificationTypes = [
//         { id: 'all', label: 'All' },
//         { id: 'stock', label: 'Stock' },
//         { id: 'order', label: 'Orders' },
//         { id: 'payment', label: 'Payments' },
//         { id: 'system', label: 'System' }
//     ];

//     return (
//         <div style={{
//             backgroundColor: 'white',
//             borderRadius: '10px',
//             padding: isMobile ? '15px' : '30px',
//             boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
//         }}>
//             {/* Header Section */}
//             <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '15px',
//                 marginBottom: '30px',
//                 flexDirection: isMobile ? 'column' : 'row',
//                 textAlign: isMobile ? 'center' : 'left'
//             }}>
                

//                 <div style={{
//                     display: 'flex',
//                     gap: '10px',
//                     flexWrap: 'wrap',
//                     justifyContent: isMobile ? 'center' : 'flex-end',
//                     marginLeft: isMobile ? '0' : 'auto'
//                 }}>
//                     <button
//                         onClick={markAllAsRead}
//                         style={{
//                             backgroundColor: '#4CAF50',
//                             color: 'white',
//                             border: 'none',
//                             padding: isMobile ? '8px 16px' : '10px 20px',
//                             borderRadius: '6px',
//                             cursor: 'pointer',
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: isMobile ? '5px' : '8px',
//                             fontSize: isMobile ? '13px' : '14px',
//                             fontWeight: '600'
//                         }}
//                     >
//                         <FaCheckCircle /> Mark All as Read
//                     </button>

//                     <button
//                         onClick={clearAllNotifications}
//                         style={{
//                             backgroundColor: '#f44336',
//                             color: 'white',
//                             border: 'none',
//                             padding: isMobile ? '8px 16px' : '10px 20px',
//                             borderRadius: '6px',
//                             cursor: 'pointer',
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: isMobile ? '5px' : '8px',
//                             fontSize: isMobile ? '13px' : '14px',
//                             fontWeight: '600'
//                         }}
//                     >
//                         <FaTrash /> Clear All
//                     </button>
//                 </div>
//             </div>

//             {/* Stats Summary - MOVED TO TOP */}
//             <div style={{
//                 display: 'grid',
//                 gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
//                 gap: '15px',
//                 marginBottom: '30px'
//             }}>
//                 <div style={{
//                     backgroundColor: '#e8f5e9',
//                     padding: isMobile ? '15px' : '20px',
//                     borderRadius: '10px',
//                     textAlign: 'center',
//                     transition: 'transform 0.2s',
//                     cursor: 'pointer'
//                 }}
//                 onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
//                 onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
//                 >
//                     <div style={{
//                         fontSize: isMobile ? '20px' : '28px',
//                         fontWeight: 'bold',
//                         color: '#2e7d32',
//                         marginBottom: '5px'
//                     }}>
//                         {notifications.length}
//                     </div>
//                     <div style={{
//                         fontSize: isMobile ? '12px' : '14px',
//                         color: '#388e3c',
//                         fontWeight: '600'
//                     }}>
//                         Total Notifications
//                     </div>
//                 </div>

//                 <div style={{
//                     backgroundColor: '#fff3e0',
//                     padding: isMobile ? '15px' : '20px',
//                     borderRadius: '10px',
//                     textAlign: 'center',
//                     transition: 'transform 0.2s',
//                     cursor: 'pointer'
//                 }}
//                 onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
//                 onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
//                 >
//                     <div style={{
//                         fontSize: isMobile ? '20px' : '28px',
//                         fontWeight: 'bold',
//                         color: '#e65100',
//                         marginBottom: '5px'
//                     }}>
//                         {unreadCount}
//                     </div>
//                     <div style={{
//                         fontSize: isMobile ? '12px' : '14px',
//                         color: '#ef6c00',
//                         fontWeight: '600'
//                     }}>
//                         Unread
//                     </div>
//                 </div>

//                 <div style={{
//                     backgroundColor: '#e3f2fd',
//                     padding: isMobile ? '15px' : '20px',
//                     borderRadius: '10px',
//                     textAlign: 'center',
//                     transition: 'transform 0.2s',
//                     cursor: 'pointer'
//                 }}
//                 onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
//                 onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
//                 >
//                     <div style={{
//                         fontSize: isMobile ? '20px' : '28px',
//                         fontWeight: 'bold',
//                         color: '#1565c0',
//                         marginBottom: '5px'
//                     }}>
//                         {notifications.filter(n => n.channel === 'sms').length}
//                     </div>
//                     <div style={{
//                         fontSize: isMobile ? '12px' : '14px',
//                         color: '#1976d2',
//                         fontWeight: '600'
//                     }}>
//                         SMS Notifications
//                     </div>
//                 </div>

//                 <div style={{
//                     backgroundColor: '#f3e5f5',
//                     padding: isMobile ? '15px' : '20px',
//                     borderRadius: '10px',
//                     textAlign: 'center',
//                     transition: 'transform 0.2s',
//                     cursor: 'pointer'
//                 }}
//                 onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
//                 onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
//                 >
//                     <div style={{
//                         fontSize: isMobile ? '20px' : '28px',
//                         fontWeight: 'bold',
//                         color: '#7b1fa2',
//                         marginBottom: '5px'
//                     }}>
//                         {notifications.filter(n => n.type === 'stock').length}
//                     </div>
//                     <div style={{
//                         fontSize: isMobile ? '12px' : '14px',
//                         color: '#8e24aa',
//                         fontWeight: '600'
//                     }}>
//                         Stock Alerts
//                     </div>
//                 </div>
//             </div>

//             {/* Filters and Search */}
//             <div style={{
//                 backgroundColor: '#f8f9fa',
//                 padding: isMobile ? '15px' : '20px',
//                 borderRadius: '10px',
//                 marginBottom: '20px'
//             }}>
//                 <div style={{
//                     display: 'flex',
//                     flexDirection: isMobile ? 'column' : 'row',
//                     gap: '15px',
//                     alignItems: isMobile ? 'stretch' : 'center'
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '10px',
//                         flexWrap: 'wrap',
//                         justifyContent: isMobile ? 'center' : 'flex-start'
//                     }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                             <FaFilter style={{ color: '#666' }} />
//                             <span style={{
//                                 fontSize: isMobile ? '13px' : '14px',
//                                 fontWeight: '600',
//                                 color: '#333'
//                             }}>
//                                 Filter:
//                             </span>
//                         </div>
//                         <div style={{
//                             display: 'flex',
//                             gap: '8px',
//                             flexWrap: 'wrap',
//                             justifyContent: isMobile ? 'center' : 'flex-start'
//                         }}>
//                             {notificationTypes.map(type => (
//                                 <button
//                                     key={type.id}
//                                     onClick={() => setFilterType(type.id)}
//                                     style={{
//                                         padding: isMobile ? '6px 12px' : '8px 16px',
//                                         border: 'none',
//                                         backgroundColor: filterType === type.id ? '#A055B0' : '#e0e0e0',
//                                         color: filterType === type.id ? 'white' : '#333',
//                                         borderRadius: '20px',
//                                         cursor: 'pointer',
//                                         fontSize: isMobile ? '12px' : '13px',
//                                         fontWeight: '600',
//                                         flexShrink: 0,
//                                         transition: 'all 0.2s'
//                                     }}
//                                 >
//                                     {type.label}
//                                 </button>
//                             ))}
//                         </div>
//                     </div>

//                     <div style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '10px',
//                         marginLeft: isMobile ? '0' : 'auto'
//                     }}>
//                         <button
//                             onClick={() => setSortOrder(sortOrder === 'newest' ? 'oldest' : 'newest')}
//                             style={{
//                                 padding: isMobile ? '6px 12px' : '8px 16px',
//                                 border: '1px solid #ddd',
//                                 backgroundColor: 'white',
//                                 color: '#333',
//                                 borderRadius: '6px',
//                                 cursor: 'pointer',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '6px',
//                                 fontSize: isMobile ? '12px' : '13px',
//                                 fontWeight: '600',
//                                 flexShrink: 0,
//                                 transition: 'all 0.2s'
//                             }}
//                         >
//                             {sortOrder === 'newest' ? <FaSortAmountDown /> : <FaSortAmountUp />}
//                             {sortOrder === 'newest' ? 'Newest' : 'Oldest'}
//                         </button>

//                         <div style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '8px',
//                             flex: isMobile ? 1 : 'none'
//                         }}>
//                             <FaSearch style={{ color: '#666' }} />
//                             <input
//                                 type="text"
//                                 placeholder="Search notifications..."
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 style={{
//                                     padding: isMobile ? '8px 12px' : '10px 15px',
//                                     border: '1px solid #ddd',
//                                     borderRadius: '6px',
//                                     fontSize: isMobile ? '13px' : '14px',
//                                     width: '100%',
//                                     minWidth: isMobile ? 'auto' : '200px',
//                                     boxSizing: 'border-box'
//                                 }}
//                             />
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Notifications List */}
//             <div style={{
//                 backgroundColor: '#fff',
//                 borderRadius: '10px',
//                 border: '1px solid #e0e0e0',
//                 overflow: 'hidden',
//                 minHeight: '300px',
//                 marginBottom: '20px',
//                 maxHeight: '500px',
//                 overflowY: 'auto',
//                 scrollBehavior: 'smooth'
//             }}>
//                 {filteredNotifications.length === 0 ? (
//                     <div style={{
//                         padding: isMobile ? '40px 20px' : '60px 20px',
//                         textAlign: 'center',
//                         color: '#666'
//                     }}>
//                         <FaBell style={{
//                             fontSize: isMobile ? '48px' : '64px',
//                             marginBottom: '15px',
//                             opacity: 0.3
//                         }} />
//                         <h4 style={{
//                             margin: '0 0 10px 0',
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px'
//                         }}>
//                             No notifications found
//                         </h4>
//                         <p style={{
//                             fontSize: isMobile ? '13px' : '14px',
//                             margin: 0
//                         }}>
//                             Try adjusting your filters or search terms
//                         </p>
//                     </div>
//                 ) : (
//                     filteredNotifications.map(notification => (
//                         <div
//                             key={notification.id}
//                             style={{
//                                 padding: isMobile ? '12px 15px' : '15px 20px',
//                                 borderBottom: '1px solid #e0e0e0',
//                                 backgroundColor: notification.read ? '#fff' : '#f8f9fa',
//                                 display: 'flex',
//                                 alignItems: 'flex-start',
//                                 gap: isMobile ? '10px' : '15px',
//                                 position: 'relative',
//                                 transition: 'background-color 0.2s'
//                             }}
//                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
//                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = notification.read ? '#fff' : '#f8f9fa'}
//                         >
//                             {/* Unread Indicator */}
//                             {!notification.read && (
//                                 <div style={{
//                                     position: 'absolute',
//                                     left: '0',
//                                     top: '0',
//                                     bottom: '0',
//                                     width: '4px',
//                                     backgroundColor: getPriorityColor(notification.priority)
//                                 }}></div>
//                             )}

//                             {/* Notification Icon */}
//                             <div style={{
//                                 width: isMobile ? '40px' : '50px',
//                                 height: isMobile ? '40px' : '50px',
//                                 borderRadius: '8px',
//                                 backgroundColor: getPriorityColor(notification.priority) + '20',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 color: getPriorityColor(notification.priority),
//                                 fontSize: isMobile ? '18px' : '22px',
//                                 flexShrink: 0
//                             }}>
//                                 {getTypeIcon(notification.type)}
//                             </div>

//                             {/* Notification Content */}
//                             <div style={{ flex: 1, minWidth: 0 }}>
//                                 <div style={{
//                                     display: 'flex',
//                                     flexDirection: isMobile ? 'column' : 'row',
//                                     justifyContent: 'space-between',
//                                     alignItems: isMobile ? 'flex-start' : 'flex-start',
//                                     marginBottom: '8px',
//                                     gap: isMobile ? '8px' : '0'
//                                 }}>
//                                     <div style={{ flex: 1, minWidth: 0 }}>
//                                         <div style={{
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             gap: '8px',
//                                             marginBottom: '5px',
//                                             flexWrap: 'wrap'
//                                         }}>
//                                             <h4 style={{
//                                                 margin: 0,
//                                                 fontSize: isMobile ? '14px' : '16px',
//                                                 color: '#333',
//                                                 fontWeight: notification.read ? '600' : '700',
//                                                 wordBreak: 'break-word'
//                                             }}>
//                                                 {notification.title}
//                                             </h4>
//                                             <span style={{
//                                                 fontSize: isMobile ? '10px' : '11px',
//                                                 color: 'white',
//                                                 backgroundColor: getPriorityColor(notification.priority),
//                                                 padding: '2px 8px',
//                                                 borderRadius: '10px',
//                                                 textTransform: 'uppercase',
//                                                 fontWeight: 'bold',
//                                                 flexShrink: 0
//                                             }}>
//                                                 {notification.priority}
//                                             </span>
//                                         </div>
//                                         <p style={{
//                                             margin: '0 0 8px 0',
//                                             fontSize: isMobile ? '13px' : '14px',
//                                             color: '#666',
//                                             lineHeight: '1.5',
//                                             wordBreak: 'break-word'
//                                         }}>
//                                             {notification.message}
//                                         </p>
//                                     </div>

//                                     <div style={{
//                                         display: 'flex',
//                                         flexDirection: 'column',
//                                         gap: '6px',
//                                         alignItems: isMobile ? 'flex-start' : 'flex-end',
//                                         width: isMobile ? '100%' : 'auto'
//                                     }}>
//                                         <div style={{
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             gap: '10px',
//                                             flexWrap: 'wrap'
//                                         }}>
//                                             <span style={{
//                                                 fontSize: isMobile ? '11px' : '12px',
//                                                 color: '#999',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '5px',
//                                                 flexShrink: 0
//                                             }}>
//                                                 <FaCalendarAlt /> {notification.timestamp}
//                                             </span>

//                                             <span style={{
//                                                 fontSize: isMobile ? '11px' : '12px',
//                                                 color: '#666',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '5px',
//                                                 flexShrink: 0
//                                             }}>
//                                                 {getChannelIcon(notification.channel)}
//                                                 <span style={{ textTransform: 'capitalize' }}>
//                                                     {notification.channel}
//                                                 </span>
//                                             </span>
//                                         </div>

//                                         {/* Action Buttons */}
//                                         <div style={{
//                                             display: 'flex',
//                                             gap: '8px',
//                                             flexWrap: 'wrap'
//                                         }}>
//                                             {!notification.read && (
//                                                 <button
//                                                     onClick={() => markAsRead(notification.id)}
//                                                     style={{
//                                                         backgroundColor: 'transparent',
//                                                         color: '#2196F3',
//                                                         border: '1px solid #2196F3',
//                                                         padding: '4px 10px',
//                                                         borderRadius: '4px',
//                                                         cursor: 'pointer',
//                                                         fontSize: isMobile ? '12px' : '13px',
//                                                         display: 'flex',
//                                                         alignItems: 'center',
//                                                         gap: '5px',
//                                                         flexShrink: 0,
//                                                         transition: 'all 0.2s'
//                                                     }}
//                                                 >
//                                                     <FaCheckCircle /> Read
//                                                 </button>
//                                             )}

//                                             <button
//                                                 onClick={() => deleteNotification(notification.id)}
//                                                 style={{
//                                                     backgroundColor: 'transparent',
//                                                     color: '#f44336',
//                                                     border: '1px solid #f44336',
//                                                     padding: '4px 10px',
//                                                     borderRadius: '4px',
//                                                     cursor: 'pointer',
//                                                     fontSize: isMobile ? '12px' : '13px',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     gap: '5px',
//                                                     flexShrink: 0,
//                                                     transition: 'all 0.2s'
//                                                 }}
//                                             >
//                                                 <FaTrash /> Delete
//                                             </button>

//                                             <button
//                                                 onClick={() => alert(`Viewing details for: ${notification.title}`)}
//                                                 style={{
//                                                     backgroundColor: 'transparent',
//                                                     color: '#4CAF50',
//                                                     border: '1px solid #4CAF50',
//                                                     padding: '4px 10px',
//                                                     borderRadius: '4px',
//                                                     cursor: 'pointer',
//                                                     fontSize: isMobile ? '12px' : '13px',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     gap: '5px',
//                                                     flexShrink: 0,
//                                                     transition: 'all 0.2s'
//                                                 }}
//                                             >
//                                                 <FaEye /> Details
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     ))
//                 )}
//             </div>
//         </div>
//     );
// }

// export default NotificationHistory;






import React, { useState } from "react";
import {
    FaBell,
    FaHistory,
    FaCheckCircle,
    FaTrash,
    FaFilter,
    FaSearch,
    FaEye,
    FaCalendarAlt,
    FaSortAmountDown,
    FaSortAmountUp,
    FaBox,
    FaShoppingCart,
    FaStar,
    FaRupeeSign,
    FaCog,
    FaSms,
    FaMobileAlt,
    FaEnvelope
} from "react-icons/fa";

function NotificationHistory({ isMobile }) {
    // State for notification history
    const [notifications, setNotifications] = useState([
        {
            id: 1,
            type: 'stock',
            title: 'Low Stock Alert',
            message: 'Paneer Tikka is running low (5 items left)',
            timestamp: '2024-03-20 14:30:00',
            read: true,
            channel: 'sms',
            priority: 'high'
        },
        {
            id: 2,
            type: 'order',
            title: 'High-Value Order',
            message: 'Order #ORD-78945 worth ₹12,500 received',
            timestamp: '2024-03-20 12:15:00',
            read: true,
            channel: 'sms',
            priority: 'high'
        },
        {
            id: 3,
            type: 'payment',
            title: 'Payment Received',
            message: '₹8,750 payment processed for Order #ORD-78945',
            timestamp: '2024-03-20 09:20:00',
            read: false,
            channel: 'sms',
            priority: 'medium'
        },
        {
            id: 4,
            type: 'stock',
            title: 'Critical Stock Level',
            message: 'Basmati Rice needs restocking (2 items left)',
            timestamp: '2024-03-19 11:30:00',
            read: true,
            channel: 'sms',
            priority: 'critical'
        },
        {
            id: 5,
            type: 'system',
            title: 'System Maintenance',
            message: 'Scheduled maintenance on March 22, 2:00 AM - 4:00 AM',
            timestamp: '2024-03-19 16:10:00',
            read: false,
            channel: 'push',
            priority: 'low'
        },
        {
            id: 6,
            type: 'order',
            title: 'Order Confirmation',
            message: 'Order #ORD-78946 confirmed for ₹2,450',
            timestamp: '2024-03-19 14:45:00',
            read: true,
            channel: 'sms',
            priority: 'medium'
        },
        {
            id: 7,
            type: 'stock',
            title: 'Restock Reminder',
            message: 'Butter Chicken Masala running low (8 items left)',
            timestamp: '2024-03-19 10:15:00',
            read: true,
            channel: 'sms',
            priority: 'medium'
        },
        {
            id: 8,
            type: 'payment',
            title: 'Payment Failed',
            message: 'Payment failed for Order #ORD-78947. Please check.',
            timestamp: '2024-03-18 18:30:00',
            read: true,
            channel: 'sms',
            priority: 'high'
        }
    ]);

    // State for UI
    const [filterType, setFilterType] = useState('all');
    const [searchQuery, setSearchQuery] = useState('');
    const [sortOrder, setSortOrder] = useState('newest');

    // Mark notification as read
    const markAsRead = (id) => {
        setNotifications(prev =>
            prev.map(notification =>
                notification.id === id ? { ...notification, read: true } : notification
            )
        );
    };

    // Mark all as read
    const markAllAsRead = () => {
        setNotifications(prev =>
            prev.map(notification => ({ ...notification, read: true }))
        );
    };

    // Delete notification
    const deleteNotification = (id) => {
        setNotifications(prev =>
            prev.filter(notification => notification.id !== id)
        );
    };

    // Clear all notifications
    const clearAllNotifications = () => {
        setNotifications([]);
    };

    // Filter and sort notifications
    const filteredNotifications = notifications
        .filter(notification => {
            const matchesType = filterType === 'all' || notification.type === filterType;
            const matchesSearch =
                notification.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                notification.message.toLowerCase().includes(searchQuery.toLowerCase());

            return matchesType && matchesSearch;
        })
        .sort((a, b) => {
            const dateA = new Date(a.timestamp);
            const dateB = new Date(b.timestamp);
            return sortOrder === 'newest' ? dateB - dateA : dateA - dateB;
        });

    // Get unread count
    const unreadCount = notifications.filter(n => !n.read).length;

    // Get priority color
    const getPriorityColor = (priority) => {
        switch (priority) {
            case 'critical': return '#f44336';
            case 'high': return '#ff9800';
            case 'medium': return '#2196f3';
            case 'low': return '#4caf50';
            default: return '#757575';
        }
    };

    // Get type icon
    const getTypeIcon = (type) => {
        switch (type) {
            case 'stock': return <FaBox />;
            case 'order': return <FaShoppingCart />;
            case 'review': return <FaStar />;
            case 'payment': return <FaRupeeSign />;
            case 'system': return <FaCog />;
            default: return <FaBell />;
        }
    };

    // Get channel icon
    const getChannelIcon = (channel) => {
        switch (channel) {
            case 'sms': return <FaSms />;
            case 'push': return <FaMobileAlt />;
            case 'email': return <FaEnvelope />;
            default: return <FaBell />;
        }
    };

    // Notification types for filtering
    const notificationTypes = [
        { id: 'all', label: 'All' },
        { id: 'stock', label: 'Stock' },
        { id: 'order', label: 'Orders' },
        { id: 'payment', label: 'Payments' },
        { id: 'system', label: 'System' }
    ];

    return (
        <div style={{
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: isMobile ? '15px' : '30px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
            {/* Header Section */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                marginBottom: '30px',
                flexDirection: isMobile ? 'column' : 'row',
                textAlign: isMobile ? 'center' : 'left'
            }}>
                

                <div style={{
                    display: 'flex',
                    gap: '10px',
                    flexWrap: 'wrap',
                    justifyContent: isMobile ? 'center' : 'flex-end',
                    marginLeft: isMobile ? '0' : 'auto'
                }}>
                    <button
                        onClick={markAllAsRead}
                        style={{
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            padding: isMobile ? '8px 16px' : '10px 20px',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: isMobile ? '5px' : '8px',
                            fontSize: isMobile ? '13px' : '14px',
                            fontWeight: '600'
                        }}
                    >
                        <FaCheckCircle /> Mark All as Read
                    </button>

                    <button
                        onClick={clearAllNotifications}
                        style={{
                            backgroundColor: '#f44336',
                            color: 'white',
                            border: 'none',
                            padding: isMobile ? '8px 16px' : '10px 20px',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: isMobile ? '5px' : '8px',
                            fontSize: isMobile ? '13px' : '14px',
                            fontWeight: '600'
                        }}
                    >
                        <FaTrash /> Clear All
                    </button>
                </div>
            </div>

            {/* Stats Summary - MOVED TO TOP */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                gap: '15px',
                marginBottom: '30px'
            }}>
                <div style={{
                    backgroundColor: '#e8f5e9',
                    padding: isMobile ? '15px' : '20px',
                    borderRadius: '10px',
                    textAlign: 'center',
                    transition: 'transform 0.2s',
                    cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                    <div style={{
                        fontSize: isMobile ? '20px' : '28px',
                        fontWeight: 'bold',
                        color: '#2e7d32',
                        marginBottom: '5px'
                    }}>
                        {notifications.length}
                    </div>
                    <div style={{
                        fontSize: isMobile ? '12px' : '14px',
                        color: '#388e3c',
                        fontWeight: '600'
                    }}>
                        Total Notifications
                    </div>
                </div>

                <div style={{
                    backgroundColor: '#fff3e0',
                    padding: isMobile ? '15px' : '20px',
                    borderRadius: '10px',
                    textAlign: 'center',
                    transition: 'transform 0.2s',
                    cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                    <div style={{
                        fontSize: isMobile ? '20px' : '28px',
                        fontWeight: 'bold',
                        color: '#e65100',
                        marginBottom: '5px'
                    }}>
                        {unreadCount}
                    </div>
                    <div style={{
                        fontSize: isMobile ? '12px' : '14px',
                        color: '#ef6c00',
                        fontWeight: '600'
                    }}>
                        Unread
                    </div>
                </div>

                <div style={{
                    backgroundColor: '#e3f2fd',
                    padding: isMobile ? '15px' : '20px',
                    borderRadius: '10px',
                    textAlign: 'center',
                    transition: 'transform 0.2s',
                    cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                    <div style={{
                        fontSize: isMobile ? '20px' : '28px',
                        fontWeight: 'bold',
                        color: '#1565c0',
                        marginBottom: '5px'
                    }}>
                        {notifications.filter(n => n.channel === 'sms').length}
                    </div>
                    <div style={{
                        fontSize: isMobile ? '12px' : '14px',
                        color: '#1976d2',
                        fontWeight: '600'
                    }}>
                        SMS Notifications
                    </div>
                </div>

                <div style={{
                    backgroundColor: '#f3e5f5',
                    padding: isMobile ? '15px' : '20px',
                    borderRadius: '10px',
                    textAlign: 'center',
                    transition: 'transform 0.2s',
                    cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                    <div style={{
                        fontSize: isMobile ? '20px' : '28px',
                        fontWeight: 'bold',
                        color: '#7b1fa2',
                        marginBottom: '5px'
                    }}>
                        {notifications.filter(n => n.type === 'stock').length}
                    </div>
                    <div style={{
                        fontSize: isMobile ? '12px' : '14px',
                        color: '#8e24aa',
                        fontWeight: '600'
                    }}>
                        Stock Alerts
                    </div>
                </div>
            </div>

            {/* Filters and Search */}
            <div style={{
                backgroundColor: '#f8f9fa',
                padding: isMobile ? '15px' : '20px',
                borderRadius: '10px',
                marginBottom: '20px'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: '15px',
                    alignItems: isMobile ? 'stretch' : 'center'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        flexWrap: 'wrap',
                        justifyContent: isMobile ? 'center' : 'flex-start'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <FaFilter style={{ color: '#666' }} />
                            <span style={{
                                fontSize: isMobile ? '13px' : '14px',
                                fontWeight: '600',
                                color: '#333'
                            }}>
                                Filter:
                            </span>
                        </div>
                        <div style={{
                            display: 'flex',
                            gap: '8px',
                            flexWrap: 'wrap',
                            justifyContent: isMobile ? 'center' : 'flex-start'
                        }}>
                            {notificationTypes.map(type => (
                                <button
                                    key={type.id}
                                    onClick={() => setFilterType(type.id)}
                                    style={{
                                        padding: isMobile ? '6px 12px' : '8px 16px',
                                        border: 'none',
                                        backgroundColor: filterType === type.id ? '#A055B0' : '#e0e0e0',
                                        color: filterType === type.id ? 'white' : '#333',
                                        borderRadius: '20px',
                                        cursor: 'pointer',
                                        fontSize: isMobile ? '12px' : '13px',
                                        fontWeight: '600',
                                        flexShrink: 0,
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    {type.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        marginLeft: isMobile ? '0' : 'auto'
                    }}>
                        <button
                            onClick={() => setSortOrder(sortOrder === 'newest' ? 'oldest' : 'newest')}
                            style={{
                                padding: isMobile ? '6px 12px' : '8px 16px',
                                border: '1px solid #ddd',
                                backgroundColor: 'white',
                                color: '#333',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                fontSize: isMobile ? '12px' : '13px',
                                fontWeight: '600',
                                flexShrink: 0,
                                transition: 'all 0.2s'
                            }}
                        >
                            {sortOrder === 'newest' ? <FaSortAmountDown /> : <FaSortAmountUp />}
                            {sortOrder === 'newest' ? 'Newest' : 'Oldest'}
                        </button>

                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            flex: isMobile ? 1 : 'none'
                        }}>
                            <FaSearch style={{ color: '#666' }} />
                            <input
                                type="text"
                                placeholder="Search notifications..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{
                                    padding: isMobile ? '8px 12px' : '10px 15px',
                                    border: '1px solid #ddd',
                                    borderRadius: '6px',
                                    fontSize: isMobile ? '13px' : '14px',
                                    width: '100%',
                                    minWidth: isMobile ? 'auto' : '200px',
                                    boxSizing: 'border-box'
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Notifications List */}
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '10px',
                border: '1px solid #e0e0e0',
                overflow: 'hidden',
                minHeight: '300px',
                marginBottom: '20px',
                //maxHeight: '500px',
                overflowY: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'none'
            }}>
                {filteredNotifications.length === 0 ? (
                    <div style={{
                        padding: isMobile ? '40px 20px' : '60px 20px',
                        textAlign: 'center',
                        color: '#666'
                    }}>
                        <FaBell style={{
                            fontSize: isMobile ? '48px' : '64px',
                            marginBottom: '15px',
                            opacity: 0.3
                        }} />
                        <h4 style={{
                            margin: '0 0 10px 0',
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px'
                        }}>
                            No notifications found
                        </h4>
                        <p style={{
                            fontSize: isMobile ? '13px' : '14px',
                            margin: 0
                        }}>
                            Try adjusting your filters or search terms
                        </p>
                    </div>
                ) : (
                    filteredNotifications.map(notification => (
                        <div
                            key={notification.id}
                            style={{
                                padding: isMobile ? '12px 15px' : '15px 20px',
                                borderBottom: '1px solid #e0e0e0',
                                backgroundColor: notification.read ? '#fff' : '#f8f9fa',
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: isMobile ? '10px' : '15px',
                                position: 'relative',
                                transition: 'background-color 0.2s'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = notification.read ? '#fff' : '#f8f9fa'}
                        >
                            {/* Unread Indicator */}
                            {!notification.read && (
                                <div style={{
                                    position: 'absolute',
                                    left: '0',
                                    top: '0',
                                    bottom: '0',
                                    width: '4px',
                                    backgroundColor: getPriorityColor(notification.priority)
                                }}></div>
                            )}

                            {/* Notification Icon */}
                            <div style={{
                                width: isMobile ? '40px' : '50px',
                                height: isMobile ? '40px' : '50px',
                                borderRadius: '8px',
                                backgroundColor: getPriorityColor(notification.priority) + '20',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: getPriorityColor(notification.priority),
                                fontSize: isMobile ? '18px' : '22px',
                                flexShrink: 0
                            }}>
                                {getTypeIcon(notification.type)}
                            </div>

                            {/* Notification Content */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: isMobile ? 'column' : 'row',
                                    justifyContent: 'space-between',
                                    alignItems: isMobile ? 'flex-start' : 'flex-start',
                                    marginBottom: '8px',
                                    gap: isMobile ? '8px' : '0'
                                }}>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            marginBottom: '5px',
                                            flexWrap: 'wrap'
                                        }}>
                                            <h4 style={{
                                                margin: 0,
                                                fontSize: isMobile ? '14px' : '16px',
                                                color: '#333',
                                                fontWeight: notification.read ? '600' : '700',
                                                wordBreak: 'break-word'
                                            }}>
                                                {notification.title}
                                            </h4>
                                            <span style={{
                                                fontSize: isMobile ? '10px' : '11px',
                                                color: 'white',
                                                backgroundColor: getPriorityColor(notification.priority),
                                                padding: '2px 8px',
                                                borderRadius: '10px',
                                                textTransform: 'uppercase',
                                                fontWeight: 'bold',
                                                flexShrink: 0
                                            }}>
                                                {notification.priority}
                                            </span>
                                        </div>
                                        <p style={{
                                            margin: '0 0 8px 0',
                                            fontSize: isMobile ? '13px' : '14px',
                                            color: '#666',
                                            lineHeight: '1.5',
                                            wordBreak: 'break-word'
                                        }}>
                                            {notification.message}
                                        </p>
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '6px',
                                        alignItems: isMobile ? 'flex-start' : 'flex-end',
                                        width: isMobile ? '100%' : 'auto'
                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            flexWrap: 'wrap'
                                        }}>
                                            <span style={{
                                                fontSize: isMobile ? '11px' : '12px',
                                                color: '#999',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px',
                                                flexShrink: 0
                                            }}>
                                                <FaCalendarAlt /> {notification.timestamp}
                                            </span>

                                            <span style={{
                                                fontSize: isMobile ? '11px' : '12px',
                                                color: '#666',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px',
                                                flexShrink: 0
                                            }}>
                                                {getChannelIcon(notification.channel)}
                                                <span style={{ textTransform: 'capitalize' }}>
                                                    {notification.channel}
                                                </span>
                                            </span>
                                        </div>

                                        {/* Action Buttons */}
                                        <div style={{
                                            display: 'flex',
                                            gap: '8px',
                                            flexWrap: 'wrap'
                                        }}>
                                            {!notification.read && (
                                                <button
                                                    onClick={() => markAsRead(notification.id)}
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#2196F3',
                                                        border: '1px solid #2196F3',
                                                        padding: '4px 10px',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        fontSize: isMobile ? '12px' : '13px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '5px',
                                                        flexShrink: 0,
                                                        transition: 'all 0.2s'
                                                    }}
                                                >
                                                    <FaCheckCircle /> Read
                                                </button>
                                            )}

                                            <button
                                                onClick={() => deleteNotification(notification.id)}
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#f44336',
                                                    border: '1px solid #f44336',
                                                    padding: '4px 10px',
                                                    borderRadius: '4px',
                                                    cursor: 'pointer',
                                                    fontSize: isMobile ? '12px' : '13px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '5px',
                                                    flexShrink: 0,
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                <FaTrash /> Delete
                                            </button>

                                            <button
                                                onClick={() => alert(`Viewing details for: ${notification.title}`)}
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    color: '#4CAF50',
                                                    border: '1px solid #4CAF50',
                                                    padding: '4px 10px',
                                                    borderRadius: '4px',
                                                    cursor: 'pointer',
                                                    fontSize: isMobile ? '12px' : '13px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '5px',
                                                    flexShrink: 0,
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                <FaEye /> Details
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default NotificationHistory;